import type { BulkOperationProduct } from '../..'
import type { UpdateableProduct } from '../../../area-substrates'

export default function convertToUpdateableProductOption(oldProduct: BulkOperationProduct): UpdateableProduct {
  const price = oldProduct.price ? oldProduct.price : 0
  const newProduct = {
    ...oldProduct,
    color: oldProduct.color ?? '',
    coverage: { default: oldProduct.coverage, useCustom: false, custom: 0 },
    lnftCoverage: { default: oldProduct.lnftCoverage, useCustom: false, custom: 0 },
    quantityCoverage: { default: oldProduct.quantityCoverage, useCustom: false, custom: 0 },
    volume: { default: 0, useCustom: false, custom: 0 },
    price: { default: price, useCustom: false, custom: 0 },
    totalPrice: { default: 0, useCustom: false, custom: 0 }
  }
  return newProduct
}
